import { Theme } from "../../Theme";
// export const appBar = {
//   background: "transparent",
//   padding: " 1em",
//   display: "flex",
//   justifyContent: "space-between",
//   flexWrap:"wrap",
//   margin:"auto"
// };
export const appBar = {
  padding:"20px"
}

export const dialogContainer = {
  // backgroundColor:"rgb(99 97 100)"
  backgroundColor:"white"
}
export const searchBoxContainer = {
  display: "flex",
  flex: "1",
  alignItems: "center",
  borderRadius: "24px",
  justifyContent: "center",
};

export const searchBox = {
  height: "35px",
  padding: "11px",
  border: "none",
  width: "50%",
  outline: "none",
  backgroundColor: Theme.primaryBody,
  color:Theme.white
};

export const searchButton = {
  width: "5em",
  outline: "none",
  border: "none",
  height: "35px",
  backgroundColor: "rgb(69 64 64)",
  cursor:"pointer"
};